<div>
  <div *ngFor="let entry of versionEntries" class="versions-stack">
    <sbb-version-entries
      [isWritable]="variant.isWritable"
      [model]="entry"
      [lastAddedVersion]="lastAddedVersion"
      [publishDisabled]="publishDisabled | async"
      (display)="onDisplay($event)"
      (restore)="onRestore($event)"
      (dropChanges)="onDropChangesClicked()"
      (ignoreConflict)="onIgnoreConflict()"
      (saveAsNewVariant)="onSaveAsNewVariant($event)"
      (publish)="onPublishClicked($event)"
      (download)="onDownload($event)"
    >
    </sbb-version-entries>
  </div>
</div>
